import React, { useEffect, useState } from "react";
import { ModalScreen } from "../../components/ModalScreen";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { ValFormReg } from "../../../Validators/ValForms";
import { RegularExpressions } from "../../../Helpers/RegularExpression";
import { TextField } from "@mui/material";
import { ValSpecialCharacters } from "../../../Validators/ValSpecialCharacters";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PercentIcon from "@mui/icons-material/Percent";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import WarningIcon from "@mui/icons-material/Warning";


export const ModalCondicionesOperacion = ({
  open,
  setOpenSolicitud,
  loader,
  setLoader,
  folio,
  idproceso,
  iddocumento,
}) => {
  const [comentarios, setComentarios] = useState("");
  const [condiciones, setCondiciones] = useState({});

  const [estatus, setEstatus] = useState({});  

  const onChange = (prop, value, sbool, smensaje) => {
    setComentarios(value);
  };

  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`ACAnalisisDecicion/Condiciones?folio=${folio}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setCondiciones(result);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "VALIDAR CONDICIONES DE LA OPERACION",
          JSON.stringify(error),
          "error"
        );
      });
  }, []);

  const onEnviarComentario = (valor) => {
    const rescomentarios = ValFormReg(
      "Comentarios",
      comentarios,
      RegularExpressions.TextSpecialCharacter,
      15,
      2000
    );
    if (rescomentarios.isValid === false) {
      Swal.fire(
        "VALIDAR CONDICIONES DE LA OPERACION",
        rescomentarios.mensaje,
        "error"
      );
      return;
    }
    setLoader({ ...loader, mostrar: true });
    const post = {
      folio,
      comentarios,
      estatus: valor,
      idproceso: idproceso,
    };
    request
      .post("AC_Validar_Condiciones_Operacion/EnviarComentario", post)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setEstatus(result.estado);
       
        setComentarios("");
        Swal.fire({
          title: "VALIDACION DE CONDICIONES",
          text: "Registro guardado con éxito",
          icon: "success",
          customClass: {
            container: "mi-superpoop",
          },
        });
        setOpenSolicitud(false);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  };
  return (
    <ModalScreen close={setOpenSolicitud}>
      <span
        className="filtro-soy-span-close"
        onClick={() => setOpenSolicitud(false)}
      >
        X
      </span>
      <PlantillaScreen
        titulo={"Condiciones de la operación"}
        className={"asc-modal"}
      >
        <div className="modal-validacion-condiciones-operacion-container-solicitud-condicionada scroll">
          <div
            className={`solicitud-condicionada-modal-condiciones-operacion-content-timeline solicitud-condicionada-modal-condiciones-operacion-content-timeline-general`}
          >
            <label>Condiciones</label>
            <div className="solicitud-condicionada-modal-condiciones-operacion-content-timeline-svg">
              {/* <OnGetIcon icon={estatus.icono} /> */}
            </div>
            <div className="solicitud-condicionada-modal-condiciones-operacion-content-timeline-div">
              {condiciones.condiciones}
            </div>
          </div>
          <div
            className={`solicitud-condicionada-modal-condiciones-operacion-content-timeline solicitud-condicionada-modal-condiciones-operacion-content-timeline-general`}
          >
            <label>Observaciones</label>
            <div className="solicitud-condicionada-modal-condiciones-operacion-content-timeline-svg">
              {/* <OnGetIcon icon={estatus.icono} /> */}
            </div>
            <div className="solicitud-condicionada-modal-condiciones-operacion-content-timeline-div">
              {condiciones.observaciones}
            </div>
          </div>
          <div className="solicitud-condicionada-modal-condiciones-operacion-content-timeline-two-labels">
            <div
              className={`solicitud-condicionada-modal-condiciones-operacion-content-timeline-two-labels solicitud-condicionada-modal-condiciones-operacion-content-timeline-general`}
            >
              <label>Deposito</label>
              <div className="solicitud-condicionada-modal-condiciones-operacion-content-timeline-svg-two-labels">
                <AttachMoneyIcon />
              </div>
              <div className="solicitud-condicionada-modal-condiciones-operacion-content-timeline-div-two-labels">
                {FormatMoney(condiciones.deposito)}
              </div>
            </div>{" "}
            <div
              className={`solicitud-condicionada-modal-condiciones-operacion-content-timeline-two-labels solicitud-condicionada-modal-condiciones-operacion-content-timeline-general`}
            >
              <label>Anticipo</label>
              <div className="solicitud-condicionada-modal-condiciones-operacion-content-timeline-svg-two-labels">
                <AttachMoneyIcon />
              </div>
              <div className="solicitud-condicionada-modal-condiciones-operacion-content-timeline-div-two-labels">
                {FormatMoney(condiciones.anticipo)}
              </div>
            </div>
          </div>
          <div className="solicitud-condicionada-modal-condiciones-operacion-content-timeline-three-labels">
            <div
              className={`solicitud-condicionada-modal-condiciones-operacion-content-timeline-three-labels solicitud-condicionada-modal-condiciones-operacion-content-timeline-general`}
            >
              <label>Tasa</label>
              <div className="solicitud-condicionada-modal-condiciones-operacion-content-timeline-svg-three-labels">
                <PercentIcon />
              </div>
              <div className="solicitud-condicionada-modal-condiciones-operacion-content-timeline-div-three-labels">
                {condiciones.taza}
              </div>
            </div>
            <div
              className={`solicitud-condicionada-modal-condiciones-operacion-content-timeline-three-labels solicitud-condicionada-modal-condiciones-operacion-content-timeline-general`}
            >
              <label>Plazo</label>
              <div className="solicitud-condicionada-modal-condiciones-operacion-content-timeline-svg-three-labels">
                <CalendarMonthIcon />
              </div>
              <div className="solicitud-condicionada-modal-condiciones-operacion-content-timeline-div-three-labels">
                {`${condiciones.tiempo_plazo} ${condiciones.plazo}`}
              </div>
            </div>
            {/* <div
                            className={`solicitud-condicionada-modal-condiciones-operacion-content-timeline-three-labels solicitud-condicionada-modal-condiciones-operacion-content-timeline-general`}
                        >
                            <label>Tiempo</label>
                            <div className="solicitud-condicionada-modal-condiciones-operacion-content-timeline-svg-three-labels">
                                <AccessTimeIcon />
                            </div>
                            <div className="solicitud-condicionada-modal-condiciones-operacion-content-timeline-div-three-labels">
                                {condiciones.tiempo_plazo}
                            </div>
                        </div> */}
          </div>
        </div>

        <div className="solicitud-condicionada-modal-condiciones-operacion-content-timeline-comentarios-container">
          <TextField
            fullWidth
            size="small"
            label="COMENTARIOS"
            className=""
            multiline
            rows={4}
            type="text"
            onChange={({ target }) => {
              ValSpecialCharacters(
                "condiciones",
                target.value,
                onChange,
                true,
                500
              );
            }}
            value={comentarios}
          />
          <div className="solicitud-condicionada-modal-condiciones-operacion-content-timeline-container-buttons">
            {/* <div
                            className="analisis-credito-modal-mhusa-content-acept-button"
                            onClick={() => {
                                onEnviarComentario("A");
                            }}
                        >
                            <CheckCircleIcon />
                            <div>Aceptar condiciones de la operación</div>
                        </div> */}
            <div
              className="analisis-credito-modal-mhusa-content-warning-button"
              onClick={() => {
                onEnviarComentario("M");
              }}
            >
              <WarningIcon />
              <div>Solicitar cambio en las condiciones</div>
            </div>
          </div>
        </div>
        <div className="analisis-as-screen-footer"></div>
      </PlantillaScreen>
    </ModalScreen>
  );
};
